import { connect } from 'react-redux';
import ConfirmDeleteModal from './shared/confirm_delete_modal.jsx';

import {
  closeModal
} from 'zoomforth_codesbane_editor/action_creators/editor_modals.js';

import {
  revertToVersion
} from 'zoomforth_codesbane_editor/action_creators/versioning.js';

import { get as getPageHistoryTracker } from 'zoomforth_zf/appglobals/page-history-tracker.js';

const mapStateToProps = () => {
  return {
    title: 'Are you sure you want to revert to a previous version?',
    body: 'Any work that has not been published will be deleted. This cannot be undone.',
    confirmText: 'Revert Site',
    cancelText: 'Cancel'
  };
};


const mapDispatchToProps = (dispatch, { version }) => (
  {
    onCancel: ()=> { 
      dispatch(closeModal()); 
    },
    onConfirm: ()=> { 
      getPageHistoryTracker().trackDiscardChanges();
      dispatch(revertToVersion(version));
      dispatch(closeModal());
    }
  }
);

const ConfirmRevertToVersionModal = connect(
  mapStateToProps,
  mapDispatchToProps
)(ConfirmDeleteModal);

ConfirmRevertToVersionModal.editorModalName = 'ConfirmRevertToVersionModal';

export default ConfirmRevertToVersionModal;
